// extracted by mini-css-extract-plugin
module.exports = {"container":"ShortMenuList_container__1ZNAe"};